import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../components/PageShell";
import { ArrowRight } from "lucide-react";

const BASE = "https://a60da7d5-98cd-4edf-8f8b-29323669d79.vercel.app";

const work = [
  { title: "Grace Community Church", tag: "Church merch", img: `${BASE}/images/generated/business-polos-team.png` },
  { title: "Riverside Family Reunion", tag: "Family event", img: `${BASE}/images/products/342.png` },
  { title: "Bloom Boutique staff polos", tag: "Business", img: `${BASE}/images/generated/polo-classic.png` },
  { title: "Youth Camp 2025", tag: "Camps", img: `${BASE}/images/products/349.png` },
  { title: "Faith Journal Launch", tag: "Personalized gifts", img: `${BASE}/images/site/box-img.jpg` },
  { title: "Cornerstone Wedding Party", tag: "Wedding", img: `${BASE}/images/products/561.png` },
  { title: "Hope Bible Study group", tag: "Small group", img: `${BASE}/images/generated/hoodie-premium.png` },
  { title: "Bakery mug launch", tag: "Drinkware", img: `${BASE}/images/site/mug-img.jpg` },
];

export default function OurWork() {
  return (
    <PageShell kicker="Our Work" title="Real orders, real stories" subtitle="A glimpse at the projects we’ve had the honor of printing for churches, families, teams and businesses.">
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {work.map((w) => (
          <div key={w.title} className="group bg-white rounded-2xl overflow-hidden border border-[color:var(--dms-navy)]/10 hover-lift">
            <div className="aspect-square overflow-hidden bg-[color:var(--dms-cream-2)]">
              <img src={w.img} alt={w.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="p-5">
              <p className="kicker text-[10px]">{w.tag}</p>
              <p className="font-serif text-lg text-[color:var(--dms-navy)] mt-2">{w.title}</p>
            </div>
          </div>
        ))}
      </section>
      <section className="bg-[color:var(--dms-navy)] py-16">
        <div className="max-w-3xl mx-auto text-center px-5">
          <h2 className="font-serif text-3xl md:text-4xl text-white">Want to be next?</h2>
          <div className="mt-8"><Link to="/custom-design" className="btn-peach">Start my project <ArrowRight className="w-4 h-4" /></Link></div>
        </div>
      </section>
    </PageShell>
  );
}
